module.exports = __webpack_public_path__ + "img/branding-banner2.3554143e.jpg";